import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MeetingSectionTitle from 'modules/one_on_ones/components/MeetingSectionTitle'

import TaskModal from './TaskModal'
import TasksDataTable from './TasksDataTable'

interface Props {
  meetingId: string
  participantIds: string[]
  canAddTask: boolean
}

const TaskSection = ({ meetingId, participantIds, canAddTask }: Props) => {
  const [showTaskModal, setShowTaskModal] = useState(false)

  const onClick = () => {
    setShowTaskModal(true)
  }

  return (
    <Box
      gap="s32"
      paddingY="s32"
      component="ul"
      border={{
        top: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
    >
      <MeetingSectionTitle
        title={i18n.t('one_on_ones.meeting.tasks.title')}
        isBeta={false}
        button={
          canAddTask ? (
            <Button type="secondary" onClick={onClick} iconName="add">
              {i18n.t('one_on_ones.meeting.tasks.button')}
            </Button>
          ) : undefined
        }
      />
      <TasksDataTable meetingId={meetingId} />
      {showTaskModal && (
        <TaskModal
          meetingId={meetingId}
          participantIds={participantIds}
          onClose={() => {
            setShowTaskModal(false)
          }}
        />
      )}
    </Box>
  )
}
export default TaskSection
